<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <!-- Movil: regresa al submenu de Inventario sin usar el boton atras del equipo -->
        <router-link class="btn btn-sm btn-info d-inline-flex align-items-center d-md-none mb-3 cot-btn-regresar"
          :to="{ name: 'dashboard', query: { modulo: 'inv' } }">
          <i class="os-icon os-icon-chevrons-left sliding-icon"></i>
          <span class="ml-1">Regresar al menú</span>
        </router-link>
        <h5 class="form-header">Cotizaciones de Requerimiento</h5>
        <div class="form-desc">
          Cotizaciones a clientes que respaldan requerimientos de traslado que exceden el máximo de la tienda.
          No generan pedido.
        </div>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-4">
              <router-link class="btn btn-sm btn-primary"
                :to="{ name: 'inventario-cotizaciones-requerimiento-nuevo', params: {} }">
                Nueva Cotización &nbsp;
                <i class="fa fa-plus-square"></i>
              </router-link>
              <button type="button" class="btn btn-sm btn-dark ml-1" @click="trasladarATienda">
                Trasladar a Tienda &nbsp;
                <i class="fa fa-exchange-alt"></i>
              </button>
            </div>
            <div class="col-sm-8">
              <div class="form-inline justify-content-sm-end">
                <select class="form-control form-control-sm rounded bright" v-model="filter.tienda"
                  @change="filterData(1)">
                  <option value="">Todas las tiendas</option>
                  <option v-for="(item, key) in tiendas" :value="item.codigo" :key="key">
                    {{ item.codigo }} - {{ item.nombre }}
                  </option>
                </select>
                <select class="form-control form-control-sm rounded bright" v-model="filter.estado"
                  @change="filterData(1)">
                  <option value="">Estatus</option>
                  <option value="A">Abierta</option>
                  <option value="B">Cerrada</option>
                  <option value="9">Anulada</option>
                </select>
                <input class="form-control form-control-sm rounded bright" placeholder="Número"
                  v-model="filter.numero" type="text" style="width: 90px" v-on:keyup.enter="filterData(1)" />
                <input class="form-control form-control-sm rounded bright" placeholder="NIT o nombre cliente"
                  v-model="filter.search" type="text" v-on:keyup.enter="filterData(1)" />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData(1)">
                    <i class="fa fa-search"></i>
                    Buscar
                  </button>
                  <button class="btn btn-link btn-sm" type="button" @click="clearFilterData()">
                    <i class="fa fa-times"></i>
                    Limpiar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Escritorio: tabla. En movil (< 768px) se usan las tarjetas de abajo -->
        <div class="table-responsive d-none d-md-block">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">Número</th>
                <th>Fecha</th>
                <th>Tienda</th>
                <th>Cliente</th>
                <th>Vence</th>
                <th class="text-center">Estado</th>
                <th>Requerimiento</th>
                <th class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" :key="current.id" @click="rowClick(current, $event)"
                style="cursor: pointer">
                <td class="text-center">
                  <b>{{ current.numero }}</b>
                  <div v-if="current.cotizacion_origen">
                    <small class="text-muted">clonada</small>
                  </div>
                </td>
                <td>{{ current.fecha }}</td>
                <td>{{ current.tienda_nombre }}</td>
                <td>({{ current.cliente_nit }}) {{ current.cliente_nombre }}</td>
                <td>
                  {{ current.fecha_vence }}
                  <span v-if="current.esta_vencida" class="badge badge-danger">Vencida</span>
                </td>
                <td class="text-center">
                  <span class="badge" :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'B',
                    'badge-danger': current.estado == '9',
                  }">{{ current.estado_str }}</span>
                </td>
                <td>
                  <span v-if="current.requerimiento">
                    #{{ current.requerimiento.numero }}
                    <small class="text-muted">({{ current.requerimiento.estado_str }})</small>
                  </span>
                  <span v-else class="text-muted">{{ textoSinRequerimiento(current) }}</span>
                </td>
                <td class="text-right">Q {{ current.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Movil: una tarjeta por cotizacion con toda su informacion; las vencidas se muestran opacas -->
        <div class="d-md-none" v-if="data && data.results">
          <div v-if="data.results.length === 0" class="text-center text-muted py-3">
            No hay cotizaciones para mostrar.
          </div>
          <button v-for="current in data.results" :key="'movil_' + current.id" type="button" class="cot-item"
            :class="{
              'cot-item-abierta': current.estado == 'A',
              'cot-item-cerrada': current.estado == 'B',
              'cot-item-anulada': current.estado == '9',
              'cot-item-vencida': current.esta_vencida,
            }" @click="rowClick(current, $event)">
            <div class="cot-item-fila">
              <span>
                <b>#{{ current.numero }}</b>
                <small v-if="current.cotizacion_origen" class="text-muted ml-1">clonada</small>
              </span>
              <span class="badge" :class="{
                'badge-success': current.estado == 'A',
                'badge-warning': current.estado == 'B',
                'badge-danger': current.estado == '9',
              }">{{ current.estado_str }}</span>
            </div>
            <div class="cot-item-cliente">({{ current.cliente_nit }}) {{ current.cliente_nombre }}</div>
            <small class="d-block text-muted">
              {{ current.fecha }} &middot; {{ current.tienda_nombre }}
            </small>
            <small class="d-block">
              <span class="text-muted">Vence:</span> {{ current.fecha_vence }}
              <span v-if="current.esta_vencida" class="text-danger"> &middot; Vencida</span>
            </small>
            <div class="cot-item-fila mt-1">
              <small>
                <span class="text-muted">Requerimiento:</span>
                <span v-if="current.requerimiento">
                  #{{ current.requerimiento.numero }}
                  <span class="text-muted">({{ current.requerimiento.estado_str }})</span>
                </span>
                <span v-else class="text-muted">{{ textoSinRequerimiento(current) }}</span>
              </small>
              <b class="text-success">Q {{ formatoMonto(current.total) }}</b>
            </div>
          </button>
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="filterData" />
      </div>
    </div>
    <!-- Traslado desde el listado: la tienda destino se elige en la ventana, sin crear una cotizacion vacia -->
    <TrasladarCotizacionModal ref="modalTraslado" @trasladada="onTrasladada" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import TrasladarCotizacionModal from "./TrasladarCotizacionModal";

export default {
  components: {
    PaginationComponent,
    TrasladarCotizacionModal,
  },
  data() {
    return {
      currentPage: 1,
      data: {},
      filter: {
        tienda: "",
        estado: "",
        numero: "",
        search: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    this.filterData(1);
  },
  methods: {
    filterData(page) {
      if (page) {
        this.currentPage = page;
      }
      DynamicService.fetch("cxc", "cotizaciones", {
        page: this.currentPage,
        tienda: this.filter.tienda,
        estado: this.filter.estado,
        numero: this.filter.numero,
        "filter[search]": this.filter.search,
      }).then((response) => {
        this.data = response.data;
      });
    },
    clearFilterData() {
      this.filter = {
        tienda: "",
        estado: "",
        numero: "",
        search: "",
      };
      this.filterData(1);
    },
    formatoMonto(valor) {
      // 43.5 -> 43.50
      const numero = Number(valor || 0);
      return numero.toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    textoSinRequerimiento(current) {
      // Misma regla que Cotizaciones.disponibles_para_requerimiento: solo cerrada y vigente
      if (current.estado == "9") {
        return "No aplica";
      }
      if (current.estado == "A") {
        return "Pendiente de cerrar";
      }
      if (current.esta_vencida) {
        return "Vencida";
      }
      return "Disponible";
    },
    trasladarATienda() {
      this.$refs.modalTraslado.abrir();
    },
    onTrasladada(data) {
      Notifications.toast.success(
        "Cotización Trasladada",
        `Se creó la cotización #${data.numero} a partir de la #${data.numero_origen} de la tienda ${data.tienda_origen}, que quedó anulada.`
      );
      (data.advertencias || []).forEach((mensaje) => {
        Notifications.toast.warning("Advertencia", mensaje);
      });
      this.$router.push({
        name: "inventario-cotizaciones-requerimiento-editar",
        params: { id: data.cotizacion_e },
      });
    },
    rowClick(current, event) {
      const ruta = {
        name: "inventario-cotizaciones-requerimiento-editar",
        params: { id: current.id },
      };
      if (event && event.ctrlKey) {
        window.open(this.$router.resolve(ruta).href, "_blank");
      } else {
        this.$router.push(ruta);
      }
    },
  },
};
</script>

<style scoped>
.cot-btn-regresar {
  min-height: 36px;
}

/* Listado en tarjetas (movil) */
.cot-item {
  display: block;
  width: 100%;
  text-align: left;
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-left-width: 4px;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 8px;
}

.cot-item:active,
.cot-item:hover {
  background-color: #f3f7ff;
}

.cot-item-abierta {
  border-left-color: #24b314;
}

.cot-item-cerrada {
  border-left-color: #f8bc34;
}

.cot-item-anulada {
  border-left-color: #e65252;
}

/* Igual que en el listado de cotizacion movil: las vencidas se ven opacas */
.cot-item-vencida {
  background-color: #f1f1f1;
  opacity: 0.6;
}

.cot-item-vencida:active,
.cot-item-vencida:hover {
  background-color: #e9e9e9;
}

.cot-item-fila {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cot-item-cliente {
  font-size: 0.95rem;
  margin: 2px 0;
  overflow-wrap: anywhere;
}
</style>
